export default function handleBookEventModal(){
    $('body').on('click', '.js-book-event', function(){
        $('.js-modal-book-event').addClass('modal--active');
        $('body').addClass('modal-active');
        return false;
    }).on('click', '.js-modal-book-event .js-close-modal', function(){
        $('.js-modal-book-event').removeClass('modal--active');
        $('body').removeClass('modal-active');
        return false;
    });
}
